import React from 'react';
import { StepContainer } from '../StepContainer';
import { FormSection } from './form/formSection';
import { FormItem } from './form/formItem';

interface SanitaireStepProps {
  data: any;
  onChange: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const SanitaireStep: React.FC<SanitaireStepProps> = ({
  data = {
    sallesDeBain: {},
    sanitaires: {},
    accessibilite: {},
    carrelage: {},
    mobilier: {},
    ventilation: {}
  },
  onChange,
  onNext,
  onBack
}) => {
  const updateSection = (section: string, key: string, value: any) => {
    onChange({
      ...data,
      [section]: {
        ...data[section],
        [key]: value
      }
    });
  };

  return (
    <StepContainer
      title="Sanitaire et Salles d'eau"
      description="Détaillez les travaux pour les salles de bain et sanitaires"
      onNext={onNext}
      onBack={onBack}
    >
      <div className="space-y-6">
        <FormSection
          title="1. Création ou rénovation de salles de bain"
          description="Type d'intervention sur la salle de bain"
        >
          <div className="space-y-4">
            <FormItem
              label="Forfait création complète d'une salle de bain (sans détails)"
              value={data.sallesDeBain?.creation || { selected: false }}
              onChange={(value) => updateSection('sallesDeBain', 'creation', value)}
              withQuantity
            />
            <FormItem
              label="Forfait rénovation d'une salle de bain existante (sans détails)"
              value={data.sallesDeBain?.renovation || { selected: false }}
              onChange={(value) => updateSection('sallesDeBain', 'renovation', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="2. Installation ou remplacement de sanitaires"
          description="Équipements sanitaires à installer"
        >
          <div className="space-y-4">
            <FormItem
              label="Installation/remplacement de lavabo"
              value={data.sanitaires?.lavabo || { selected: false }}
              onChange={(value) => updateSection('sanitaires', 'lavabo', value)}
              withQuantity
            />
            <FormItem
              label="Installation/remplacement de douche classique"
              value={data.sanitaires?.doucheClassique || { selected: false }}
              onChange={(value) => updateSection('sanitaires', 'doucheClassique', value)}
              withQuantity
            />
            <FormItem
              label="Installation/remplacement de douche à l'italienne"
              value={data.sanitaires?.doucheItalienne || { selected: false }}
              onChange={(value) => updateSection('sanitaires', 'doucheItalienne', value)}
              withQuantity
            />
            <FormItem
              label="Installation/remplacement de baignoire"
              value={data.sanitaires?.baignoire || { selected: false }}
              onChange={(value) => updateSection('sanitaires', 'baignoire', value)}
              withQuantity
            />
            <FormItem
              label="Installation/remplacement de WC suspendu"
              value={data.sanitaires?.wcSuspendu || { selected: false }}
              onChange={(value) => updateSection('sanitaires', 'wcSuspendu', value)}
              withQuantity
            />
            <FormItem
              label="Installation/remplacement de WC classique"
              value={data.sanitaires?.wcClassique || { selected: false }}
              onChange={(value) => updateSection('sanitaires', 'wcClassique', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="3. Aménagements spécifiques pour l'accessibilité"
          description="Équipements pour l'accessibilité"
        >
          <div className="space-y-4">
            <FormItem
              label="Installation de barres d'appui"
              value={data.accessibilite?.barresAppui || { selected: false }}
              onChange={(value) => updateSection('accessibilite', 'barresAppui', value)}
              withQuantity
            />
            <FormItem
              label="Installation d'une douche adaptée PMR"
              value={data.accessibilite?.doucheAdaptee || { selected: false }}
              onChange={(value) => updateSection('accessibilite', 'doucheAdaptee', value)}
              withQuantity
            />
            <FormItem
              label="Installation d'un WC adapté PMR"
              value={data.accessibilite?.wcAdapte || { selected: false }}
              onChange={(value) => updateSection('accessibilite', 'wcAdapte', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="4. Mobilier de salle de bain"
          description="Meubles à installer"
        >
          <div className="space-y-4">
            <FormItem
              label="Installation de meuble vasque"
              value={data.mobilier?.meubleVasque || { selected: false }}
              onChange={(value) => updateSection('mobilier', 'meubleVasque', value)}
              withQuantity
            />
            <FormItem
              label="Installation de colonne de rangement"
              value={data.mobilier?.colonne || { selected: false }}
              onChange={(value) => updateSection('mobilier', 'colonne', value)}
              withQuantity
            />
            <FormItem
              label="Installation de miroir"
              value={data.mobilier?.miroir || { selected: false }}
              onChange={(value) => updateSection('mobilier', 'miroir', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="5. Ventilation et extraction d'humidité"
          description="Système de ventilation à installer"
        >
          <div className="space-y-4">
            <FormItem
              label="Installation d'extracteur d'air"
              value={data.ventilation?.extracteur || { selected: false }}
              onChange={(value) => updateSection('ventilation', 'extracteur', value)}
              withQuantity
            />
            <FormItem
              label="Amélioration de la ventilation naturelle"
              value={data.ventilation?.naturelle || { selected: false }}
              onChange={(value) => updateSection('ventilation', 'naturelle', value)}
              withQuantity
            />
          </div>
        </FormSection>
      </div>
    </StepContainer>
  );
};

export default SanitaireStep;